// A header, not a query parameter: the reader's title is free-text PII, and a URL is captured
// verbatim by Datadog RUM resource events, dd-trace's http.url span tag and every ALB access log.
export const READER_TITLE_HEADER = 'x-reader-title';

export const encodeReaderTitle = (title: string): string | undefined => {
  try {
    return encodeURIComponent(title);
  } catch {
    return undefined;
  }
};

export const decodeReaderTitle = (value: string): string | undefined => {
  try {
    return decodeURIComponent(value);
  } catch {
    return undefined;
  }
};
